import { useUIDSeed } from 'react-uid';
export default function useUniqueId(prefix, shouldRenderId) {
  var seed = useUIDSeed();
  return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}